import { Navigate } from "react-router-dom";
import { useGuard } from "../hooks/useGuard";
import { useRBACStore } from "../zustand/useRBACStore";
import { useEffect } from "react";

export default function RBACRouteGuard({ children, route, allowedUserTypes, requiredPermission }) {
  const { isAllowedUserTypes, hasPermission } = useGuard();
  const { currentProfile } = useRBACStore();

  if (!isAllowedUserTypes(allowedUserTypes, currentProfile?.profileType, currentProfile?.role, route) 
      || !hasPermission(requiredPermission, currentProfile?.profileType, currentProfile?.permissions)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
